import { Button } from 'shared/components/ui/button';
import styled from 'styled-components';

export const CtaButton = styled(Button)`
  && {
    padding-top: ${({ theme }) => theme.spacing(4)};
    padding-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;
